import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { style: {"min-height":"400px"} }
const _hoisted_9 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_10 = { class: "dropdown ml-auto" }
const _hoisted_11 = { class: "dropdown-menu dropdown-menu-right dropdown-menu-scrollable" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  class: "form-inline my-2 my-lg-0 ml-sm-2",
  role: "search"
}
const _hoisted_14 = {
  key: 0,
  class: "alert alert-info alert-dismissible fade show d-flex align-items-center mt-3",
  role: "alert"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "table table-bordered" }
const _hoisted_19 = { style: {"width":"40px","min-width":"40px !important"} }
const _hoisted_20 = { class: "btn-group" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { class: "fg-color-gray mb-0 mt-1" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = ["disabled"]

import { computed, toRef } from 'vue'
    import type { UserReadModel } from '@Alternatives/Assignments/Domain/readmodels'
    import { AssignUsersEventPayload } from '@Alternatives/Assignments/Components/UsersAssignerDialog'
    import type { UsersAssignerDialogViewModel } from '@Alternatives/Assignments/Components/UsersAssignerDialog'


    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersAssignerDialog',
  props: {
    viewModel: {}
  },
  emits: ["assign-users"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const dialogTitle = computed(() => vm.value.dialogTitle)

    // filters (writable, v-model targets)
    const searchPhrase = computed<string | null>({
        get: () => vm.value.searchPhrase,
        set: val => { vm.value.searchPhrase = val }
    })

    const tag = computed<string | null>({
        get: () => vm.value.tag,
        set: val => { vm.value.tag = val }
    })

    const usersView = computed<UserReadModel[]>(() => vm.value.usersView ?? [])
    const tags = computed(() => vm.value.tags)

    // selection helpers
    const noneSelected = computed(() => !vm.value.users.some(u => u.IsUiSelected))
    const allSelected = computed(() => !vm.value.users.some(u => !u.IsUiSelected))
    const anySelected = computed(() => vm.value.users.some(u => u.IsUiSelected))
    const selected = computed(() => vm.value.users.filter(u => u.IsUiSelected))

    // ---------------- methods ----------------

    function clearFilters()
    {
        tag.value = null
        searchPhrase.value = null
    }

    function selectAll()
    {
        usersView.value.forEach(u => u.IsUiSelected = true)
    }

    function unselectAll()
    {
        vm.value.users.forEach(u => u.IsUiSelected = false)
    }

    function handleAssign()
    {
        emit(
            'assign-users',
            new AssignUsersEventPayload(
                vm.value.alternativeIds,
                selected.value.map(u => u.Id)
            )
        )
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (!vm.value.closed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(dialogTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("nav", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm dropdown-toggle d-flex align-items-center", tag.value ? 'btn-info' : 'btn-outline-secondary']),
                        type: "button",
                        "data-toggle": "dropdown"
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-filter mr-1", tag.value ? 'text-warning' : 'text-muted'])
                        }, null, 2 /* CLASS */),
                        _cache[2] || (_cache[2] = _createElementVNode("span", null, "Tag", -1 /* CACHED */))
                      ], 2 /* CLASS */),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("a", {
                          class: _normalizeClass(["dropdown-item", { 'active': tag.value === null }]),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (tag.value = null))
                        }, " None ", 2 /* CLASS */),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (t) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: _normalizeClass(["dropdown-item", { 'active': tag.value === t }]),
                            key: t,
                            onClick: ($event: any) => (tag.value = t)
                          }, _toDisplayString(t), 11 /* TEXT, CLASS, PROPS */, _hoisted_12))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("form", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        type: "search",
                        placeholder: "Search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchPhrase).value = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, searchPhrase.value]
                      ])
                    ])
                  ]),
                  (tag.value || searchPhrase.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-info-circle mr-2" }, null, -1 /* CACHED */)),
                        _createElementVNode("span", null, [
                          _cache[7] || (_cache[7] = _createTextVNode(" Showing users ", -1 /* CACHED */)),
                          (tag.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _cache[4] || (_cache[4] = _createTextVNode("filtered by tag: ", -1 /* CACHED */)),
                                _createElementVNode("strong", null, _toDisplayString(tag.value), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (tag.value && searchPhrase.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, " and "))
                            : _createCommentVNode("v-if", true),
                          (searchPhrase.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                _cache[5] || (_cache[5] = _createTextVNode("matching \"", -1 /* CACHED */)),
                                _createElementVNode("strong", null, _toDisplayString(searchPhrase.value), 1 /* TEXT */),
                                _cache[6] || (_cache[6] = _createTextVNode("\"", -1 /* CACHED */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          _cache[8] || (_cache[8] = _createTextVNode(". ", -1 /* CACHED */))
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "close ml-auto",
                          onClick: clearFilters
                        }, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("span", null, "×", -1 /* CACHED */)
                        ]))])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            (noneSelected.value)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "pointer",
                                  onClick: selectAll
                                }, [...(_cache[11] || (_cache[11] = [
                                  _createElementVNode("i", { class: "fa-regular fa-square" }, null, -1 /* CACHED */)
                                ]))]))
                              : _createCommentVNode("v-if", true),
                            (anySelected.value && !allSelected.value)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "pointer",
                                  onClick: unselectAll
                                }, [...(_cache[12] || (_cache[12] = [
                                  _createElementVNode("i", { class: "fa fa-minus-square" }, null, -1 /* CACHED */)
                                ]))]))
                              : _createCommentVNode("v-if", true),
                            (anySelected.value && allSelected.value)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  class: "pointer",
                                  onClick: unselectAll
                                }, [...(_cache[13] || (_cache[13] = [
                                  _createElementVNode("i", { class: "fa-solid fa-square-check" }, null, -1 /* CACHED */)
                                ]))]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("th", { style: {"width":"300px"} }, "User", -1 /* CACHED */)),
                        _cache[15] || (_cache[15] = _createElementVNode("th", null, "Tags", -1 /* CACHED */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersView.value, (u) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: u.Id
                        }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((u.IsUiSelected) = $event)
                            }, null, 8 /* PROPS */, _hoisted_21), [
                              [_vModelCheckbox, u.IsUiSelected]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("p", _hoisted_22, [
                              _createElementVNode("span", null, _toDisplayString(u.Name), 1 /* TEXT */)
                            ]),
                            _createElementVNode("small", _hoisted_23, _toDisplayString(u.Email), 1 /* TEXT */)
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(u.Tags, (t) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: _normalizeClass(["badge mr-1 pointer", tag.value === t ? 'badge-info' : 'badge-secondary']),
                                key: t,
                                onClick: ($event: any) => (tag.value = t)
                              }, _toDisplayString(t), 11 /* TEXT, CLASS, PROPS */, _hoisted_24))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "button",
                  disabled: selected.value.length === 0,
                  onClick: handleAssign,
                  class: "btn btn-primary"
                }, "Assign (" + _toDisplayString(selected.value.length) + ")", 9 /* TEXT, PROPS */, _hoisted_26)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})